/**
 * @desc 时效设置-sku时效详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductTimelinessSettingResponseDto>;
export function request(tsno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessSetting/skuDetails/${tsno}`, {
      method: "GET",

      ...options,
    }),
  );
}
